import { render, staticRenderFns } from "./ftoggle.vue?vue&type=template&id=42d48a20&scoped=true"
import script from "./ftoggle.vue?vue&type=script&lang=js"
export * from "./ftoggle.vue?vue&type=script&lang=js"
import style0 from "./ftoggle.vue?vue&type=style&index=0&id=42d48a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d48a20",
  null
  
)

export default component.exports